// Types
import { ValidationMessages } from '../types/contexts/formProvider';

// Static Content
import content from './content.json';

export const validationMessages: ValidationMessages = {
  required: content.required,
  notNumeric: content.notNumeric,
  invalidDate: content.invalidDate,
  dateInFuture: content.dateInFuture,
  invalidEmail: content.invalidEmail,
  invalidNumber: content.invalidNumber,
  invalidPassword: content.invalidPassword,
  numericMinNumber: content.numericMinNumber,
  numericMaxNumber: content.numericMaxNumber,
  invalidPostalCode: content.invalidPostalCode,

  exceededMaxLength: content.exceededMaxLength,
  notExceededMinLength: content.notExceededMinLength,

  contactNumberInvalid: content.contactNumberInvalid,
  contactNumberTooLong: content.contactNumberTooLong,
  contactNumberTooShort: content.contactNumberTooShort,

  radioGroupSelectAnOption: content.radioGroupSelectAnOption,

  checkboxGroupMinSelected: content.checkboxGroupMinSelected,
  checkboxGroupMaxSelected: content.checkboxGroupMaxSelected,
  checkboxGroupInvalidSelection: content.checkboxGroupInvalidSelection,
  checkboxGroupIncompleteInputs: content.checkboxGroupIncompleteInputs,

  minimumAge: content.minimumAge,

  dayBetween: content.dayBetween,
  dayRequired: content.dayRequired,
  dayNotNumeric: content.dayNotNumeric,

  monthBetween: content.monthBetween,
  monthRequired: content.monthRequired,
  monthNotNumeric: content.monthNotNumeric,

  yearToEarly: content.yearToEarly,
  yearInFuture: content.yearInFuture,
  yearRequired: content.yearRequired,
  yearNotNumeric: content.yearNotNumeric,
};
